import { useEffect, useState } from "react";
import { Image, ImageProps } from "react-native";
import { XOR } from "ts-essentials";
import { resolveAssetSource } from "../utils/resolveAssetSource";

type AutoSizeImageProps = {
    scale?: number;
} & ImageProps &
    XOR<
        {
            fixedHeight: number;
        },
        {
            fixedWidth: number;
        }
    >;

const AutoSizeImage = ({
    source,
    fixedHeight = 0,
    fixedWidth = 0,
    scale = 1,
    style,
    ...props
}: AutoSizeImageProps) => {
    const [imageHeight, setImageHeight] = useState<number>();
    const [imageWidth, setImageWidth] = useState<number>();

    useEffect(() => {
        if (source) {
            void (async () => {
            const { width, height } = await resolveAssetSource(source);
            const widthRatio = width / height;
            const heightRatio = height / width;
            if (fixedHeight) {
                setImageWidth(fixedHeight * widthRatio * scale);
            } else if (fixedWidth) {
                setImageHeight(fixedWidth * heightRatio * scale);
            }
        })();
        }
    }, [fixedHeight, fixedWidth, scale, source]);

    if (!imageWidth && !imageHeight) return null;

    return (
        <Image
            source={source}
            style={[
                style,
                {
                    width: imageWidth || fixedWidth * scale,
                    height: imageHeight || fixedHeight * scale,
                },
            ]}
            {...props}
        />
    );
};

export default AutoSizeImage;
